import { useEffect } from "react";
import CalculatorPanel from "./CalculatorPanel";

export default function CalculatorModal({
  onClose,
  tradeContext = null,
  onInsertValue = null,
}) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="w-full fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur p-3 sm:p-5"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm flex justify-center"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="w-full max-h-[calc(100dvh-5rem)] overflow-y-auto flex justify-center">
          <CalculatorPanel
            onClose={onClose}
            onInsertValue={onInsertValue}
            tradeContext={tradeContext}
          />
        </div>
      </div>
    </div>
  );
}
